import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
// import { changeLoading } from '@/util/decorators';
import SingleImageUpload from '@/component/single-image-upload.vue';
import {
  getBackgroundImage,
  initBackgroundData,
  BackgroundImageData,
  changeBackground,
} from '@/api/operation/background_image';
import CustomModal from '@/component/custom-modal.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'background-image',
  setup(__props) {

const UPLOAD_DIR = ref<string>('operation/background-image');
const background_list = ref<BackgroundImageData[]>(initBackgroundData());
const is_loading = ref<boolean>(false);
const home_header = ref<string>('');
const home_limit_time = ref<string>('');
const preview_image = ref<string>('');
const is_show_img_modal = ref<boolean>(false);
const form_item_layout = reactive<any>({ labelCol: { span: 2 }, wrapperCol: { span: 22 } });

function beforeCommonUpload(file: any) {
  if (file.size / 1024 / 1024 > 2) {
    message.error('上传图片大小不能超过2M');
    return false;
  }
}

// 显示模态窗，改变模态窗中的图片路径
function handlePreview(imageUrl: string) {
  preview_image.value = imageUrl;
  is_show_img_modal.value = true;
}

// 获取背景图数据
onMounted(async () => {
  is_loading.value = true;
  // });
  const res = await getBackgroundImage();
  if (res.status !== 200) {
    message.error((res as any).message);
    is_loading.value = false;
    return;
  }
  is_loading.value = false;
  background_list.value = initBackgroundData(res.data);
  home_header.value = background_list.value[0] ? background_list.value[0].image_url : '';
  home_limit_time.value = background_list.value[1] ? background_list.value[1].image_url : '';
});
// 保存按钮
async function clickSaveBtn() {
  const add: any = [];
  const edit: any = [];
  if (background_list.value.length <= 0) {
    add.push(
      {
        id: 1,
        type: 1,
        image_url: home_header.value ? home_header.value : '',
      },
      {
        id: 2,
        type: 2,
        image_url: home_limit_time.value ? home_limit_time.value : '',
      }
    );
  } else {
    edit.push(
      {
        id: background_list.value[0]?.id || 1,
        image_url: home_header.value
          ? home_header.value.indexOf('https') === -1
            ? `https:${home_header.value}`
            : home_header.value
          : '',
      },
      {
        id: background_list.value[1]?.id || 2,
        image_url: home_limit_time.value
          ? home_limit_time.value.indexOf('https:') === -1
            ? `https:${home_limit_time.value}`
            : home_limit_time.value
          : '',
      }
    );
  }

  const res = await changeBackground(add, edit);
  is_loading.value = true;
  if (res.status !== 200) {
    message.error((res as any).message);
    is_loading.value = false;
    return;
  }
  message.success('上传成功');
  is_loading.value = false;
  getBackgroundImage();
}

return { __sfc: true,UPLOAD_DIR, background_list, is_loading, home_header, home_limit_time, preview_image, is_show_img_modal, form_item_layout, beforeCommonUpload, handlePreview, clickSaveBtn, SingleImageUpload, CustomModal }
}

})